import { DataTable, formatDate, PageLayout, truncateMiddle } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { ClipboardListIcon } from 'lucide-react'

import { AuditMetadata } from '@/components/audit-metadata'
import { ErrorState } from '@/components/error-state'
import { useAdminOverview } from '@/hooks/use-admin-overview'
import { translateAuditType } from '@/lib/labels'

export const Route = createFileRoute('/_app/auditoria')({
  component: AuditPage,
})

function AuditPage() {
  const overview = useAdminOverview()
  const rows = overview.data?.recentAudit ?? []

  const layout = {
    icon: ClipboardListIcon,
    title: 'Auditoria',
    description: 'Eventos administrativos recentes de billing e suporte.',
  }

  if (overview.isError) {
    return (
      <PageLayout {...layout}>
        <ErrorState onRetry={() => void overview.refetch()} />
      </PageLayout>
    )
  }

  return (
    <PageLayout {...layout} contentClassName="space-y-4">
      <DataTable
        rows={rows}
        empty={overview.isLoading ? 'Carregando…' : 'Nenhum evento recente.'}
        columns={[
          {
            key: 'type',
            header: 'Evento',
            render: (row) => (
              <span className="font-medium">
                {translateAuditType(row.type)}
              </span>
            ),
          },
          {
            key: 'org',
            header: 'Organização',
            render: (row) => (
              <div>
                <p>{row.organizationName}</p>
                <p className="text-muted-foreground text-xs">
                  {row.organizationSlug ?? truncateMiddle(row.organizationId)}
                </p>
              </div>
            ),
          },
          {
            key: 'date',
            header: 'Data',
            render: (row) => formatDate(row.createdAt),
          },
          {
            key: 'metadata',
            header: 'Detalhes',
            render: (row) => <AuditMetadata metadata={row.metadata} />,
          },
        ]}
      />
    </PageLayout>
  )
}
